module.exports = __webpack_public_path__ + "static/media/aan_tafel.15b89ca9.jpg";